// removed by extract-text-webpack-plugin
module.exports = {"primaryBtn":"_2RXYXElIdaGXR09qM_FxJb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPrimaryButton/OMPrimaryButton.scss
// module id = 1656
// module chunks = 0